export const BS_INITIAL_VALUES = {
  call_id: "",
  content: {},
  ICD_axis_1: "",
  ICD_axis_2: "",
  isSigned: false,
  provider_type: "",
  session_date: "",
  session_from: "",
  session_to: "",
};

export const BS_SCHEMA = [
  {
    elementConfig: {
      label: "",
      placeholder: "Individual therapy",
      type: "text",
    },
    elementType: "input",
    name: "title",
  },
  {
    elementConfig: {
      label: "Link Call",
      options: [],
      placeholder: "",
    },
    elementType: "select",
    name: "call_id",
  },
  {
    elementConfig: {
      label: "Date",
      placeholder: "Session Date",
      type: "text",
    },
    elementType: "DatePicker",
    name: "session_date",
  },
  {
    elementConfig: {
      label: "From",
      options: [],
      placeholder: "From",
      sentenceCase: false,
    },
    elementType: "select",
    name: "session_from",
  },
  {
    elementConfig: {
      label: "To",
      options: [],
      placeholder: "To",
    },
    elementType: "select",
    name: "session_to",
  },
  {
    elementConfig: {
      label: "Patient Report or Behavior",
      placeholder: "Patient Report",
      type: "text",
    },
    elementType: "textarea",
    name: "patient_report",
  },
  {
    elementConfig: {
      label: "Interventions",
      placeholder: "Interventions",
      type: "text",
    },
    elementType: "textarea",
    name: "interventions",
  },
  {
    elementConfig: {
      label: "Intervention Reaction",
      placeholder: "Intervention Reaction",
      type: "text",
    },
    elementType: "textarea",
    name: "intervention_reaction",
  },
  {
    elementConfig: {
      label: "Patient Task",
      placeholder: "Patient Task",
      type: "text",
    },
    elementType: "textarea",
    name: "patient_task",
  },
  {
    elementConfig: {
      label: "ICD-10 Primary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_axis_1",
  },
  {
    elementConfig: {
      label: "ICD-10 Secondary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_axis_2",
  },
  {
    elementConfig: {
      classNames: "font-weight-bold",
      displayName: "Click to Sign",
      type: "checkbox",
    },
    elementType: "input",
    name: "isSigned",
  },
];

export const P_INITIAL_VALUES = {
  call_id: "",
  ICD_axis_1: "",
  ICD_axis_2: "",
  intervention_reaction: "",
  isSigned: false,
  patient_reported: "",
  prescriber_interventions: "",
  session_date: "",
  session_from: "",
  session_to: "",
};

export const P_SCHEMA = [
  {
    elementConfig: {
      label: "",
      placeholder: "Individual therapy",
      type: "text",
    },
    elementType: "input",
    name: "title",
  },
  {
    elementConfig: {
      label: "Link Call",
      options: [],
      placeholder: "",
    },
    elementType: "select",
    name: "call_id",
  },
  {
    elementConfig: {
      label: "Date",
      placeholder: "Session Date",
      type: "text",
    },
    elementType: "DatePicker",
    name: "session_date",
  },
  {
    elementConfig: {
      label: "From",
      options: [],
      placeholder: "00:00",
    },
    elementType: "select",
    name: "session_from",
  },
  {
    elementConfig: {
      label: "To",
      options: [],
      placeholder: "00:00",
      sentenceCase: false,
    },
    elementType: "select",
    name: "session_to",
  },
  {
    elementConfig: {
      label: "Patient Reported",
      placeholder: "Patient Reported",
      type: "text",
    },
    elementType: "textarea",
    name: "patient_reported",
  },
  {
    elementConfig: {
      label: "Interventions",
      placeholder: "Interventions",
      type: "text",
    },
    elementType: "textarea",
    name: "prescriber_interventions",
  },
  {
    elementConfig: {
      label: "Intervention Reaction",
      placeholder: "Intervention Reaction",
      type: "text",
    },
    elementType: "textarea",
    name: "intervention_reaction",
  },
  {
    elementConfig: {
      label: "ICD-10 Primary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_axis_1",
  },
  {
    elementConfig: {
      label: "ICD-10 Secondary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_axis_2",
  },
  {
    elementConfig: {
      classNames: "font-weight-bold",
      displayName: "Click to Sign",
      type: "checkbox",
    },
    elementType: "input",
    name: "isSigned",
  },
];
